import Box from "@mui/material/Box";

export default function GlassCard({ children, sx = {} }) {
  return (
    <Box
      sx={{
        background: "rgba(255,255,255,0.045)",
        backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
        border: "1px solid rgba(255,255,255,0.09)",
        borderRadius: "20px",
        boxShadow:
          "0 8px 40px rgba(0,0,0,0.38), inset 0 1px 0 rgba(255,255,255,0.07)",
        padding: "28px",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
